// Components==============
import CircleRadius from 'components/UI/CircleRadius/CircleRadius';
import ReflectionIcon from 'components/UI/ReflectionIcon/ReflectionIcon';
import RootReflectionModal from 'components/UI/RootReflectionModal/RootReflectionModal';
import { useMediaQ } from 'hooks/useMediaQ';
import { useRedux } from 'hooks/useRedux';
import React, { useContext } from 'react';
import { GlobalRootPersonContext } from 'utilities/GlobalContext/GlobalRootPerson';
import '../../GrowthPortfolio.module.scss';
// =========================

export default function People() {
  const people = useRedux((state) =>
    state.authentication?.user.person_data.map((p) => ({
      person: state.people?.entities.byId[p.id],
      calculatedValue: p.calculatedValue,
    }))
  )?.filter((p) => p.person) as {
    person: PeopleEntity;
    calculatedValue: number;
  }[];

  const { setRootPersonModal } = useContext(GlobalRootPersonContext);
  const query = useMediaQ('min', 1325);

  const innerRing = people.slice(0, 5);
  const outerRing = people.slice(5, 11);

  if (!people?.length) return <></>;

  return (
    <>
      {query ? (
        <>
          <CircleRadius people={outerRing} ring="outer" />
          <CircleRadius people={innerRing} ring="inner" />
        </>
      ) : (
        <div styleName="mobile-float-wrapper">
          {people.map((person) => (
            <ReflectionIcon
              key={person.person.id}
              name={person.person.name}
              image={`/storage/${person.person.image}`}
              onClick={() => setRootPersonModal(person.person)}
            />
          ))}
        </div>
      )}
      <RootReflectionModal type="person" />
    </>
  );
}
